const webPackageSaleRoutes = [
    {
        path: '/package-sale/web',
        name: 'Web Package Sale List',
        children: [
            {
                path: '',
                name: 'webPackageSale',
                component: () => import('@/modules/web_package_sale/list/List.vue'),
                meta: {
                    resource: 'public-package-sale',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Web Package Sale List',
                    breadcrumbs: [{ title: 'Web Package Sale List', routeName: 'webPackageSale' }]
                }
            },
            {
                path: ':id/edit',
                name: 'webPackageSaleEdit',
                component: () => import('@/modules/web_package_sale/entry/Edit.vue'),
                meta: {
                    resource: 'public-package-sale',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Edit Web Package Sale',
                    breadcrumbs: [
                        { title: 'Web Package Sale List', routeName: 'webPackageSale' },
                        { title: 'Edit', routeName: 'webPackageSaleEdit' }
                    ]
                }
            }
        ]
    }
]

export default webPackageSaleRoutes
